module.exports = __webpack_public_path__ + "img/woo-logo.fdbbfc4f.png";